export default `
  mutation archiveOrganisation($id: String!) {
    archiveOrganisation(id: $id) {
        id
        name
        userId
        deletedAt
        updatedAt
      }
  }
`
